// A SHARE AS THE BROWSER MODELS IT, TAX FOLDED IN (D3.16; ADR §7.7) — applied once where a share is
// read (the seat roster, My Bookings), so every pay prompt, pay-all sum, balance chip and refund line
// downstream speaks the money the wallet or the card actually moves:
//   - `payableMinor` is the share's server total when it is stamped (`withTaxedPayable`);
//   - a share re-cut after it was paid (D3.14) reads each figure with its tax twin.
// An untaxed share comes back as the same object.

import { foldTwins, withTaxedPayable, type TaxReadFields } from '@/features/payments/taxDisplay'
import type { SeatRecut } from './repriceBalance'

const RECUT_TWINS = [
  ['settledMinor', 'settledTaxMinor'],
  ['heldMinor', 'heldTaxMinor'],
  ['owedMinor', 'owedTaxMinor'],
  ['creditedMinor', 'creditedTaxMinor'],
] as const

export function withTaxedShare<T extends TaxReadFields & { payableMinor: number; recut?: SeatRecut | null }>(share: T): T {
  const folded = withTaxedPayable(share)
  const recut = folded.recut ? foldTwins(folded.recut, RECUT_TWINS) : folded.recut
  return recut === folded.recut ? folded : { ...folded, recut }
}
